"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingBlock = void 0;
const react_1 = __importDefault(require("react"));
const HostAvatar_1 = require("./bubbles/avatars/HostAvatar");
const TypingBubble_1 = require("./bubbles/TypingBubble");
const LoadingBlock = () => (react_1.default.createElement("div", { className: "flex" },
    react_1.default.createElement("div", { className: "flex w-6 xs:w-10 mr-2 flex-shrink-0 items-center relative" },
        react_1.default.createElement("div", { className: "absolute w-6 h-6 xs:w-10 xs:h-10 mb-4 xs:mb-2 flex items-center top-0" },
            react_1.default.createElement(HostAvatar_1.HostAvatar, null)),
        react_1.default.createElement("div", { className: "absolute w-6 h-6 mb-4 xs:mb-2 xs:w-10 xs:h-10 flex items-center bottom-0" },
            react_1.default.createElement("div", { className: "w-full h-full" }))),
    react_1.default.createElement("div", { className: "flex flex-col w-full" },
        react_1.default.createElement(TypingBubble_1.TypingBubble, null))));
exports.LoadingBlock = LoadingBlock;
//# sourceMappingURL=LoadingBlock.js.map